import script from "./IPushkinWarningModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IPushkinWarningModal.vue?vue&type=script&setup=true&lang=js"

import "./IPushkinWarningModal.vue?vue&type=style&index=0&id=4086774a&lang=css"

const __exports__ = script;

export default __exports__